import { coreReducer } from '../../../core/js/reducers/coreReducer';
import { helpReducer } from './helpReducer';
import { quickshopReducer } from '../../../product/js/reducers/quickshopReducer';

/**
 * Render a template string
 * @param {Number} state - The current state
 * @param {String} action - The action that was emitted
 * @returns {object} The state of the help app
 */
function helpApp(state = {}, action) {
    return {
        core: coreReducer(state.core, action),
        help: helpReducer(state.help, action),
        quickshop: quickshopReducer(state, state.quickshop, action)
    };
}

export default helpApp;
